import styled from 'react-emotion'

const Container = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    background: '#fff',
    overflow: 'hidden',
    fontSize: 16,
    '@media (max-width: 500px)': {
        fontSize: 14
    }
})

export default Container


// WEBPACK FOOTER //
// ./src/components/ContainerComponent.jsx